import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
// Shared components
import PortletContent from 'components/PortletContent';

import { forwardRef } from 'react';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getSummaryDayWeekTable } from '../../../../../services/getSumaryDayWeek';
import moment from 'moment'
import 'moment/locale/es'  
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class ResponseWeekDay extends Component {
    
    constructor(props) {
        super(props);
        var pdf=false
        if(props.isPdf===true){
            pdf=true
        }
            
        this.state = {
            currentObjectiveId: this.props.location.state.fromObjective.objetivo_id,
            loadObjectiveData: false,
            period: this.props.data.period,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'c',
            hoverData: null,
            lastEvent: [],
            isPdf:pdf,
            statePeriod: this.props.data.range,
            days:['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
            data:[]
        }  
    }

    static getDerivedStateFromProps(props, state) {
        if( moment(props.data.range.startDate).format("Y-MM-DD")!==moment(state.statePeriod.startDate).format("Y-MM-DD")){
            return{
                days:['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
                statePeriod:props.data.range,
                isLoading:true,
            }    
        }
        return null
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if (moment(prevProps.data.range.startDate).format("Y-MM-DD")!==moment(this.state.statePeriod.startDate).format("Y-MM-DD")) {
            this.getDataFromAPI();
        }

    }
    

    getDataFromAPI = () => {  
        const { currentObjectiveId,period, statePeriod } = this.state
        const { fromObjective } = this.props.location.state
        const { schedule } = this.props.data
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            // fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            // correccion para que la fecha sea hora local
            fecha_termino = moment(statePeriod.endDate).format().substring(0, 10)
            getSummaryDayWeekTable(currentObjectiveId,user,token,fecha_inicio,fecha_termino,schedule).then(data => {
                if (data.status == 1 || data.status == 5) {
                    localStorage.setItem('isAuthenticated', false);                        
                } else {
                    //Procesa la Data Recibida
                    try {
                        this.processData(data, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino,
                                schedule)
                    } catch (error) {
                        this.setState({
                            dataError: true,
                            isLoading: false
                        });
                    }
                }  
            })
        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino,
        schedule) => {
        const {days}=this.state
        const colors = ['#2199e8', '#fed12d', '#ff7373', '#ccff00', '#b6fcd5',
            '#065535', '#ffc0cb', '#008080', '#00ffff', '#ffa500',
            '#800000', '#fff68f', '#bada55', '#8a2be2', '#3b5998'];
        var listStepDays=days
        var listDataDays=[]
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        listStepDays.map((i,ele)=>{
            Object.keys(externalData).map(function(key, index) {
                if (ele == externalData[key]['index_dia']){
                    Object.keys(externalData[key]['pasos']).map(function(keyStep, indexStep) {
                        var dict={}
                        dict["dia"]=`${t(`response-weekday.days.${ele}`)}`
                        dict["paso"]=externalData[key]['pasos'][keyStep]['paso']['nombre_paso']
                        listStepDays.push({'paso':externalData[key]['pasos'][keyStep]['paso']['nombre_paso']})
                        dict["max"]=parseFloat((externalData[key]['pasos'][keyStep]['maximo']/1000).toFixed(2))
                        dict['min']=parseFloat((externalData[key]['pasos'][keyStep]['minimo']/1000).toFixed(2))
                        dict['prom']=parseFloat((externalData[key]['pasos'][keyStep]['promedio_paso']/1000).toFixed(2))
                        listDataDays.push(dict)
                    })
                }
            });
        })
        this.setState({
            data:listDataDays,
            dataError: false,
            isLoading: false,
        });

    }
    render() {
        const { dataError, chartOptions, isLoading, data, isPdf } = this.state;
        var defaultData=0
        var options={
            grouping: true
        }
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if(isPdf===true){
            defaultData=null
            options={paging:false}
        }
        if (!dataError) {
            if(isLoading===true){
                return (
                    <PortletContent>
                        <PerfectScrollbar>
                            <Typography
                                variant="h5"
                                >
                                <CircularProgress
                                variant="indeterminate"
                                size={24}
                                thickness={4}                            
                                />
                                <br/>
                                {t('text.loading')}
                            </Typography>
                        </PerfectScrollbar>
                    </PortletContent>
                )
            }else{
                return(
                    <MaterialTable
                        icons={tableIcons}
                        title=""
                        columns={[
                            { title: t('response-weekday.mui-table.columns.title.day'), field: "dia","defaultGroupOrder": {defaultData} },
                            { title: t('response-weekday.mui-table.columns.title.step'), field: "paso"},
                            { title: t('response-weekday.mui-table.columns.title.min'), field: "min", cellStyle: {textAlign: "center"}, headerStyle: {textAlign: "right"}},
                            { title: t('response-weekday.mui-table.columns.title.max'), field: "max", cellStyle: {textAlign: "center"}, headerStyle: {textAlign: "right"}},
                            { title: t('response-weekday.mui-table.columns.title.prom'), field: "prom", cellStyle: {textAlign: "center"}, headerStyle: {textAlign: "right"}},
                        ]}
                        data={data}
                        localization={t('response-weekday.mui-table.localization', {returnObjects: true})}
                        options={options}
                    />
                )
            }
        }
        else if (dataError) {
            return (<p>{t('text.no-data')}.</p>)
        }
        else return (<p>Error!</p>)

    }
}


export default compose(withRouter, withTranslation())(ResponseWeekDay);